"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionSection = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  this is in need of refactoring as it has a theme that has been borrowed from buttons applied ot it but then modified
 */
// External
var StyledAccordionSection = _styledComponents.default.div.withConfig({
  displayName: "AccordionSectionstyles__StyledAccordionSection",
  componentId: "x1zek-0"
})(["&:last-child > .c-accordion-section-content-wrapper-open{border-bottom:", " ", ";}.c-accordion-section-title-wrapper{background-color:", ";border:", " solid ", ";border-radius:", ";cursor:pointer;display:flex;justify-content:space-between;outline:none;padding:", ";width:100%;&:hover{background-color:", ";}}.c-accordion-section-left-title-wrapper,.c-accordion-section-right-title-wrapper,.c-accordion-section-sub-title{font-weight:", ";line-height:1.4rem;font-size:", ";}.c-accordion-section-left-title-wrapper{text-align:left;margin-right:1em;}.c-accordion-section-right-title-wrapper{white-space:nowrap;width:min-content;}.c-accordion-section-sub-title{color:", ";padding-right:", ";}.c-accordion-section-action-icon{font-size:1.1875rem;min-height:1.1875rem;min-width:1.1875rem;transition:transform 0.3s ease-in-out;}.c-accordion-section-action-icon-open{transform:rotate(-180deg);transition:transform 0.3s ease-in-out;}.c-accordion-section-content-wrapper{background-color:", ";border-left:", " solid ", ";border-right:", " solid ", ";height:0;margin:0 1rem;overflow:hidden;transition:height 0.3s ease-in-out,opacity 0.3s ease-in-out,border 0.3s ease-in-out;}.c-accordion-section-content-wrapper-open{height:auto;opacity:1;transition:height 0.3s ease-in-out,opacity 0.3s ease-in-out;}.c-accordion-section-own-content-wrapper{padding:", ";opacity:0;transition:height 0.3s ease-in-out,opacity 0.3s ease-in-out;& > .c-accordion-section-un-wrapped-content:not(:first-child){border-top:", " solid ", ";;}}.c-accordion-section-own-content-wrapper-open{opacity:1;}.c-accordion-section-un-wrapped-content{padding:", ";}.c-accordion-section-sub-section{.c-accordion-section-title-wrapper{padding:", ";}.c-accordion-section-left-title-wrapper,.c-accordion-section-right-title-wrapper,.c-accordion-section-sub-title{font-size:1rem;}.c-accordion-section-own-content-wrapper{padding:0;}.c-accordion-section-content-wrapper{border:none;}}"], function (props) {
  return props.theme.standardButtonBorder;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_border;
}, function (props) {
  return props.isOpen ? props.theme.c_clickable_primaryGhost_hover_background : props.theme.c_clickable_primaryGhost_background;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_border;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_hover_background;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.fontMediumSmall;
}, function (props) {
  return props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_border;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_border;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_clickable_primaryGhost_border;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledAccordionSection = StyledAccordionSection;